
export default {
    props: {
        city: Object,
    },

    methods: {
        redirToComparePage(hit) {
            this.$router.push(`/vs/${this.city.slug}/${hit.slug}/`);
        }
    }
}

